import type { OnboardingStep } from "Components/Onboarding/BusinessEntity/constants";
import { useIsCurrentUserHunter } from "Hooks/useIsCurrentUserHunter";
import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";
import { PartyType } from "Infrastructure/Api/Api";

const SHARED_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  "businessInformation",
  "incomeInformation",
  "document",
  "personalInformation",
  "handle",
];

const LEGAL_ENTITY_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  ...SHARED_ONBOARDING_FLOW,
  "beneficialOwners",
  "bankAccountConnection",
];

const SELF_EMPLOYED_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  ...SHARED_ONBOARDING_FLOW,
  "bankAccountConnection",
];

const HUNTER_LEGAL_ENTITY_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  ...SHARED_ONBOARDING_FLOW,
  "beneficialOwners",
  "licenseSelection",
  "manualLicensePayment",
];

const HUNTER_SELF_EMPLOYED_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  ...SHARED_ONBOARDING_FLOW,
  "licenseSelection",
  "manualLicensePayment",
];

const MERCHANT_LEGAL_ENTITY_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  "businessInformation",
  "incomeInformation",
  "facilityCompletion",
  "document",
  "personalInformation",
  "handle",
  "beneficialOwners",
  "bankAccountConnection",
];

const MERCHANT_SELF_EMPLOYED_ONBOARDING_FLOW: ReadonlyArray<OnboardingStep> = [
  "businessInformation",
  "incomeInformation",
  "facilityCompletion",
  "document",
  "personalInformation",
  "handle",
  "bankAccountConnection",
];

export const useOnboardingFlow = (
  partyType: PartyType,
): ReadonlyArray<OnboardingStep> => {
  const isHunter = useIsCurrentUserHunter();
  const isMerchant = useIsCurrentUserMerchant();

  if (isHunter) {
    return partyType === PartyType.LegalEntity
      ? HUNTER_LEGAL_ENTITY_ONBOARDING_FLOW
      : HUNTER_SELF_EMPLOYED_ONBOARDING_FLOW;
  }

  if (isMerchant) {
    return partyType === PartyType.LegalEntity
      ? MERCHANT_LEGAL_ENTITY_ONBOARDING_FLOW
      : MERCHANT_SELF_EMPLOYED_ONBOARDING_FLOW;
  }

  return partyType === PartyType.LegalEntity
    ? LEGAL_ENTITY_ONBOARDING_FLOW
    : SELF_EMPLOYED_ONBOARDING_FLOW;
};
